import type {Thread} from '@github-ui/diff-lines/conversation-types'

import {getFirstComment} from '../../page-data/payloads/thread-previews'
import {ChevronRightIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {PreviewAuthors} from './PreviewAuthors'
import {useNavigateToThreadComment} from '../../hooks/use-navigate-to-thread-comment'
import {getThreadCommentHref} from '../../helpers/thread-navigation'

type Props = {
  thread: Thread
  onNavigateToDiffComment?: () => void
  displayedCommentId?: number | null
  replyCount: number
}

export const NavigateToCommentButton = ({thread, onNavigateToDiffComment, displayedCommentId, replyCount}: Props) => {
  const firstComment = getFirstComment(thread)
  const commentId = displayedCommentId ?? firstComment?.databaseId
  const navigateToComment = useNavigateToThreadComment(thread, onNavigateToDiffComment, commentId)

  const repliesText = replyCount === 0 ? 'No replies' : `${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`

  return (
    <Button
      as="a"
      href={getThreadCommentHref(thread, commentId)}
      size="small"
      trailingVisual={ChevronRightIcon}
      variant="invisible"
      onClick={navigateToComment}
    >
      <div className="d-flex flex-row flex-justify-start flex-items-center gap-2">
        <span>{repliesText}</span>
        <PreviewAuthors thread={thread} skipBeforeCommentId={commentId} />
      </div>
    </Button>
  )
}
